import { render, staticRenderFns } from "./changeNameModal.vue?vue&type=template&id=15f14a12&"
import script from "./changeNameModal.vue?vue&type=script&lang=ts&"
export * from "./changeNameModal.vue?vue&type=script&lang=ts&"
import style0 from "./changeNameModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports